import { createSelector } from 'reselect';
import filter from 'lodash/filter';
import dayjs from 'core/utils/dayjs';
import { selectCurrentDate } from 'core/selectors/env';
import {
  ALPHABETICAL_ORDER, LINKED_ORDER, EARN_RATE, NEAR_ME,
} from '../components/SortBy/actions/types';
import {
  sortAlphabetical, sortLinked, sortEarnRate, sortByLocation,
} from './utils/sort';

export const selectInstoreOffers = state => state.instoreOffers;
const selectInstoreLinkCardInfo = state => state.cardLinkOffer;
const selectMapLocations = state => state.map;

export const selectInstoreOffersConfig = createSelector(
  selectInstoreOffers,
  instoreOffers => instoreOffers.config,
);

export const selectInstoreOffersIsLoading = createSelector(
  selectInstoreOffers,
  instoreOffers => instoreOffers.isLoading,
);

export const selectInstoreOffersIsLoaded = createSelector(
  selectInstoreOffers,
  instoreOffers => instoreOffers.isLoaded,
);

export const selectLinkedOffers = createSelector(
  selectInstoreOffers,
  instoreOffers => sortAlphabetical(instoreOffers.offers.filter((offer) => offer.linkedCards.length !== 0)),
);

export const selectInstoreOffersPlacements = createSelector(
  [
    selectInstoreOffers,
    selectInstoreLinkCardInfo,
    selectMapLocations,
    selectCurrentDate,
  ],
  (instoreOffers, cardLinkOffer, mapLocations, currentDate) => {
    const { offers } = instoreOffers;
    const { isLoaded, linkedCardResponse } = cardLinkOffer;
    const { sortType } = instoreOffers;
    const offerCopy = [...offers];
    const { locations } = mapLocations;
    if (isLoaded && linkedCardResponse && linkedCardResponse.length) {
      offerCopy.map((offer) => {
        let daysToExpire = null;
        linkedCardResponse.map((linkedCard) => {
          if (!linkedCard.error) {
            const { eligibleCards } = offer;
            const { paymentCard, error, expirationDate } = linkedCard;
            const { cardId } = paymentCard;

            if (error) {
              offer.showError = true;
            }

            if (offer.offerId && linkedCard.offerId && offer.offerId ===
              linkedCard.offerId && !error) {
              paymentCard.linkExpirationDate = dayjs(expirationDate).format();
              offer.eligibleCards = filter(eligibleCards,
                (card) => card.cardId !== cardId);
              offer.linkedCards.push(paymentCard);
              offer.linked = true;
            }
          }

          return linkedCard;
        });

        offer.linkedCards.forEach(card => {
          const linkCardExpiryDate = dayjs(card.linkExpirationDate);
          const expiryDays = linkCardExpiryDate.diff(currentDate, 'days');

          if (daysToExpire === null || daysToExpire > expiryDays) {
            daysToExpire = expiryDays;
          }
        });

        offer.daysToExpire = daysToExpire;

        return offer;
      });
    }

    switch (sortType) {
      case ALPHABETICAL_ORDER:
        return sortAlphabetical(offerCopy);
      case LINKED_ORDER:
        return sortLinked(offerCopy);
      case EARN_RATE:
        return sortEarnRate(offerCopy);
      case NEAR_ME:
        return sortByLocation(offerCopy, locations);
      default:
        return offerCopy;
    }
  },
);
